import {Icon, Grid, Container, Button} from "semantic-ui-react"
import React from "react"
import {useLocation} from "react-router"
import useQuery from "useQuery"
import {Link, NavLink} from "react-router-dom"
import queryString from "qs"
import _ from "lodash"

function slugify( text = "" ) {
	return text.toString().toLowerCase()
		.replace( /\s+/g, '-' )           // Replace spaces with -
		// eslint-disable-next-line no-useless-escape
		.replace( /[^\w\-]+/g, '' )       // Remove all non-word chars
		// eslint-disable-next-line no-useless-escape
		.replace( /\-\-+/g, '-' )         // Replace multiple - with single -
		.replace( /^-+/, '' )             // Trim - from start of text
		.replace( /-+$/, '' );            // Trim - from end of text
}

export function WordPressFAQ( {faq} ) {
	const location = useLocation()
	const query = useQuery()
	const [byCategory, setByCategory] = React.useState( {} )
	const [questions, setQuestions] = React.useState( [] )
	const [questionById, setQuestionById] = React.useState( [] )

	const category = byCategory[query.category]
	const question = questionById[query.q]

	React.useEffect( () => {
		let byCat = {}
		let qs = []
		let qById = {}

		faq.forEach( category => {
			category.slug = slugify( category.title )
			category.questions.forEach( q => {
				q.categoryTitle = category.title
				q.slug = slugify( q.question )
				q.categorySlug = category.slug
				qById[q.slug] = q
				qs.push( q )
			} )
			byCat[category.slug] = category
		} )
		setByCategory( (byCat) )
		setQuestions( qs )
		setQuestionById( qById )
	}, [faq] )

	return <div className="ui container pv4">
		{!category &&
		<React.Fragment>
			<h1>FAQ</h1>
			<Grid divided>
				<Grid.Row>
					<Grid.Column mobile={16} computer={4}>
						{_.chunk( faq, 3 )
							.map( ( categories, index ) => {
								return <div key={index} className="flex flex-column ">
									{categories.map( c => {
										return <div key={c.title} className={"w-100 pb2"}>
											<Button basic as={NavLink} to={{search: queryString.stringify( {category: c.slug} )}} primary className={"w-100"}>
												<div className="pv3 tl b">{c.title}</div>
											</Button>
										</div>
									} )}
								</div>
							} )}
					</Grid.Column>

					<Grid.Column mobile={16} computer={12}>
						<div className="pl3-ns">
							<h1>{translate("Häufige Fragen")}</h1>
							{questions
								.sort( ( a, b ) => Math.random() > 0.5 ? 1 : -1 )
								.slice( 0, 6 )
								.map( q => {
									return <FAQItem className="bb b--light-gray pv3" showCategory key={q.slug} q={q} />
								} )}
						</div>
					</Grid.Column>

				</Grid.Row>

			</Grid>


		</React.Fragment>
		}

		{category && <div>
			<div className="pb4 f6 f5-ns"><Link className={"blue b"} to={"/cms/faq/"}>FAQ </Link> – <span>{category.title}</span></div>

			<Grid divided>
				<Grid.Row>
					<Grid.Column mobile={16} computer={4}>
						{_.chunk( faq, 3 )
							.map( ( categories, index ) => {
								return <div key={index} className="flex flex-column ">
									{categories.map( c => {
										return <div key={c.title} className={"w-100 pb2"}>
											<Button basic={c.slug !== category.slug} as={NavLink} to={{search: queryString.stringify( {category: c.slug} )}} primary className={"w-100"}>
												<div className="pv3 b tl">{c.title}</div>
											</Button>
										</div>
									} )}
								</div>
							} )}
					</Grid.Column>

					<Grid.Column mobile={16} computer={12}>
						<div className="pl3-ns">
							<h1>{category.title}</h1>
							{category.questions.map( q => {
								return <div key={q.slug}>
									<FAQItem
										showAnswer={question === q}
										className={"bb b--light-silver pv3"} key={q.slug} q={q} />

								</div>
							} )}

						</div>
					</Grid.Column>

				</Grid.Row>

			</Grid>

		</div>}

		{/*{question && <div>*/}
		{/*	<div className="pb4 ">*/}
		{/*		<div className="f6 f5-ns"><Link className={"blue b"} to={"/cms/faq/"}>FAQ </Link> – <Link className={"blue b"} to={{search: queryString.stringify( {category: category.slug} )}}>{question.categoryTitle}</Link> – {question.question}</div>*/}
		{/*	</div>*/}
		{/*	<Grid  divided>*/}
		{/*		<Grid.Row>*/}
		{/*			<Grid.Column mobile={16} computer={4}>*/}
		{/*				<div className="pt3">*/}
		{/*					<div className="f5 black-60  pb3">Weitere Fragen aus {category.title}</div>*/}
		{/*					{category && category.questions.map( q => <FAQItem className={"pt3 f6"} key={q.slug} q={q} /> )}*/}
		{/*					<div className="pt3"><Button fluid basic as={Link} to={{pathname: "/cms/faq/", search: queryString.stringify({category: category.slug})}}>{translate("Zurück")}</Button></div>*/}

		{/*				</div>*/}
		{/*			</Grid.Column>*/}
		{/*			<Grid.Column mobile={16} computer={12}>*/}
		{/*				<div className="">*/}
		{/*					<h1 className="f2 fw2 lh-title">{question.question}</h1>*/}

		{/*<div className={"pt3 lh-copy"}>*/}
		{/*	<div className="f4" dangerouslySetInnerHTML={{__html: question.answer}} />*/}
		{/*</div>*/}
		{/*					*/}
		{/*				</div>*/}
		{/*			</Grid.Column>*/}

		{/*		</Grid.Row>*/}

		{/*	</Grid>*/}


		{/*</div>}*/}

		{/*<pre>{JSON.stringify( faq, null, 2 )}</pre>*/}
	</div>
}


function FAQItem( {q, showCategory = false, showAnswer = false, className = ""} ) {
	return <div className={`FAQItem  ${className} ${showAnswer ? "" : ""}`} key={q.question}>
		<NavLink activeClass={"underline"} className="underline-hover flex flex-row justify-between  items-center pv2  " to={{search: queryString.stringify( {q: q.slug, category: q.categorySlug} )}}>
			<div className={`b f4 black-80 `}>{q.question}</div>
			{showAnswer && <div className=""><Icon name={"chevron left "} /></div>}
			{!showAnswer && <div><Icon name={"chevron down "} /></div>}
		</NavLink>
		{showCategory && <Link className="underline-hover" to={{search: queryString.stringify( {category: q.categorySlug} )}}>
			<div className={"f6 hover-blue black-70 mt1"}>{q.categoryTitle}</div>
		</Link>}
		{showAnswer && <div className={"pt3 pb3 lh-title"}>
			<div dangerouslySetInnerHTML={{__html: q.answer}} />
		</div>}
	</div>
}


// WEBPACK FOOTER //
// ./src/WordPressFAQ.js